export function capitalise(value) {
  if (!value) return '';
  const vls = value.toString();
  return vls.charAt(0).toUpperCase() + vls.slice(1);
}

export function uppercase(value) {
  if (!value) return '';
  const vls = value.toString();
  return vls.toUpperCase();
}

export function pascalToReadable(value) {
  if (!value) return '';
  const vls = value.toString();
  return vls.replace(/([A-Z])/g, ' $1').trim();
}

export function removeT(value) { // For displaying ISO time strings.
  if (!value) return '';
  return value.replace('T', ' ');
}

export function removeUnderscores(value) {
  if (!value) return '';
  return value.replace(/_/g, ' ');
}

export function removeTAndSeconds(value) {
  if (!value) return '';
  return value.split('.')[0].replace('T', ' ').substring(0, 16);
}

export function removeTAndDateAndSeconds(value) {
  if (!value) return '';
  return value.split('.')[0].replace('T', ' ').substring(0, 16).split(' ')[1];
}

export function removeTAndDate(value) {
  if (!value) return '';
  const result = value.split('.')[0].replace('T', ' ').substring(0, 19).split(' ')[1];
  return result;
}

export function removeTAndTime(value) {
  if (!value) return '';
  return value.split('.')[0].replace('T', ' ').substring(0, 16).split(' ')[0];
}

export function removeSeconds(value) {
  if (!value) return '';
  return value.split('.')[0].substring(0, 16);
}

export function removeTAndSecondsAndFormatDate(value, format = 'en-GB') {
  if (!value) return '';
  const dateTimeWithRemovedTAndSeconds = value.split('.')[0].replace('T', ' ').substring(0, 16);
  const date = new Date(dateTimeWithRemovedTAndSeconds.split(' ')[0]);
  const time = dateTimeWithRemovedTAndSeconds.split(' ')[1];
  const formattedDate = new Intl.DateTimeFormat(format).format(date);
  return `${formattedDate} ${time}`;
}

export function roundNumbers(value, precision = 2) {
  if (!value) return '';
  const factor = Math.pow(10, precision);
  return `${Math.round(value * factor) / factor}`;
}
